import { render, staticRenderFns } from "./boardTile.vue?vue&type=template&id=be82552e&"
import script from "./boardTile.vue?vue&type=script&lang=js&"
export * from "./boardTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports